function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgLoveSalesAnalytics = function SvgLoveSalesAnalytics(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 56 56"
  }, props), /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 54041"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 19851",
    style: {
      fill: "none"
    },
    d: "M0 0h56v56H0z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 17742",
    d: "M5.6 7.6a8.884 8.884 0 0 0 0 12.564l15.169 15.169 15.166-15.166A8.884 8.884 0 0 0 23.371 7.6l-2.6 2.6-2.6-2.6A8.884 8.884 0 0 0 5.6 7.6z",
    transform: "translate(6.8 7.6)",
    style: {
      strokeLinecap: "round",
      fill: "currentColor",
      stroke: "currentColor",
      strokeLinejoin: "round",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26064",
    d: "M926.923 745.961s5.07-.857 6.252 3.073",
    transform: "translate(-892 -729)",
    style: {
      stroke: "#f1f9ff",
      strokeWidth: 3,
      strokeLinecap: "round",
      fill: "none"
    }
  })));
};

export default SvgLoveSalesAnalytics;